/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_Invalid_TypeInputs */

const en_document_invalid_type = /** @type {(inputs: Document_Invalid_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid file type. Upload PDF, image, Word, or text files.`)
};

const id_document_invalid_type = /** @type {(inputs: Document_Invalid_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis file tidak valid. Unggah PDF, gambar, Word, atau file teks.`)
};

/** @type {(inputs: Document_Invalid_TypeInputs) => LocalizedString} */
const es_document_invalid_type = en_document_invalid_type;

/** @type {(inputs: Document_Invalid_TypeInputs) => LocalizedString} */
const fr_document_invalid_type = en_document_invalid_type;

/** @type {(inputs: Document_Invalid_TypeInputs) => LocalizedString} */
const de_document_invalid_type = en_document_invalid_type;

/** @type {(inputs: Document_Invalid_TypeInputs) => LocalizedString} */
const ja_document_invalid_type = en_document_invalid_type;

/** @type {(inputs: Document_Invalid_TypeInputs) => LocalizedString} */
const zh_document_invalid_type = en_document_invalid_type;

/** @type {(inputs: Document_Invalid_TypeInputs) => LocalizedString} */
const ar_document_invalid_type = en_document_invalid_type;

/** @type {(inputs: Document_Invalid_TypeInputs) => LocalizedString} */
const it_document_invalid_type = en_document_invalid_type;

/** @type {(inputs: Document_Invalid_TypeInputs) => LocalizedString} */
const ru_document_invalid_type = en_document_invalid_type;

/** @type {(inputs: Document_Invalid_TypeInputs) => LocalizedString} */
const pt_document_invalid_type = en_document_invalid_type;

/** @type {(inputs: Document_Invalid_TypeInputs) => LocalizedString} */
const ko_document_invalid_type = en_document_invalid_type;

/**
* | output |
* | --- |
* | "Invalid file type. Upload PDF, image, Word, or text files." |
*
* @param {Document_Invalid_TypeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const document_invalid_type = /** @type {((inputs?: Document_Invalid_TypeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_Invalid_TypeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_document_invalid_type(inputs)
	if (locale === "es") return es_document_invalid_type(inputs)
	if (locale === "fr") return fr_document_invalid_type(inputs)
	if (locale === "de") return de_document_invalid_type(inputs)
	if (locale === "ja") return ja_document_invalid_type(inputs)
	if (locale === "zh") return zh_document_invalid_type(inputs)
	if (locale === "ar") return ar_document_invalid_type(inputs)
	if (locale === "id") return id_document_invalid_type(inputs)
	if (locale === "it") return it_document_invalid_type(inputs)
	if (locale === "ru") return ru_document_invalid_type(inputs)
	if (locale === "pt") return pt_document_invalid_type(inputs)
	return ko_document_invalid_type(inputs)
});